<script setup>
import { ref, computed } from 'vue';
import truncateFilter from '../plugins/truncateFilter';

//props
const { item, type, channelId, langId } = defineProps({
  item: { type: Object, default: null },
  type: { type: String, default: null },
  channelId: { type: String, default: null },
  langId: { type: String, default: null },
});

//refs
const translations = ref({
  readMore: window.Drupal.t('Read more'),
  beds: window.Drupal.t('beds'),
  sqm: window.Drupal.t('sqm'),
  included: window.Drupal.t('Included'),
});

//computed properties
const url = computed(() => {
  let url = 'https://online.bookvisit.com/'; // added languageId

  if (type === 'rooms') {
    url = url + 'accommodation/room-details?channelId=' + channelId + '&roomId=' + item.id + '&langid=' + langId;
  } else if (type === 'packages') {
    url = url + 'package/details?channelId=' + channelId + '&packageId=' + item.id + '&langid=' + langId;
  } else if (type === 'conferences') {
    url = url + 'Conference/Conference/ConferenceRoomList?channelId=' + channelId + '&packageId=' + item.id + '&langid=' + langId;
  }

  return url;
});

//methods
const totalBeds = (item) => {
  return item.numberOfBeds + item.numberOfExtrabeds;
};
</script>

<template>
  <div class="card horizontal-card shadow">
    <div class="row no-gutters">
      <div class="col-12 col-md-6">
        <img v-if="item.images" class="card-img" :src="item.images[0].url + '?maxWidth=800'" :alt="item.name" />
      </div>
      <div class="col-12 col-md-6">
        <div class="d-flex align-items-center h-100">
          <div class="card-body">
            <h4 class="card-title">{{ item.name }}</h4>
            <small class="text-muted cat d-block">
              <span v-if="item.roomSize" class="mr-2"> <i class="fas fa-expand"></i> {{ item.roomSize }} {{ translations.sqm }} </span>
              <span v-if="item.numberOfBeds"> <i class="fas fa-users"></i> {{ totalBeds(item) }} {{ translations.beds }} </span>
            </small>
            <!--
            <template v-if="item.descriptionTextShort">
              <p class="card-text" v-html="item.descriptionTextShort"></p>
            </template>-->
            <!-- Replace descriptionTextShort with description  -->
            <template v-if="item.description">
              <p class="card-text" v-html="truncateFilter(item.description, 100)"></p>
            </template>
            <template v-else-if="item.shortDescription">
              <p class="card-text" v-html="item.shortDescription"></p>
            </template>
            <template v-else-if="item.searchResultText">
              <p class="card-text" v-html="item.searchResultText"></p>
            </template>
            <template v-if="item.includedAddOns && item.includedAddOns.length > 0">
              <p class="mt-2 mb-1">{{ translations.included }}</p>
              <ul>
                <li v-for="(addon, index) in item.includedAddOns.slice(0, 3)" :key="item.id + 'addon' + index">
                  <em>{{ addon }}</em>
                </li>
              </ul>
            </template>
            <a :href="url" class="btn btn-primary">{{ translations.readMore }}</a>
          </div>
        </div>
      </div>
      <!-- <div class="col-md-2">
        <div class="card-footer h-100 d-flex align-items-center justify-content-center text-center border-0">
          <a :href="url" class="btn btn-primary">{{ translations.readMore }}</a>
        </div>
      </div> -->
    </div>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.card {
  & > .row {
    height: 450px;
  }
}
.card-img {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  height: 100%;
  object-fit: cover;
  min-height: 300px;
  max-height: 450px;
  width: 100%;
}

.card-body {
  display: flex;
  flex-direction: column;
  height: 100%;

  a.btn {
    margin-top: auto;
    width: fit-content;
  }
}

.card-title {
  margin-bottom: 0.3rem;
}

.cat {
  display: inline-block;
  margin-bottom: 1rem;
}

.card-footer {
  font-size: 0.8rem;
}
</style>
